module.exports = __webpack_public_path__ + "static/background-ipad-30fdb7d3a91129fdfd58048a658197b1.png";